module.exports = __webpack_public_path__ + "static/media/ShoppiesLogo.40909d2f.svg";